export default {
  methods: {
    isOnline() {
      return navigator.onLine;
    },
    isLoggedOutAndOnline() {
      return !this.loggedIn && navigator.onLine;
    },
    isLoggedIn() {
      return this.loggedIn;
    },
    isUserLoggedIn() {
      return this.userLoggedIn;
    },
    isLoggedInAndOnline() {
      return this.loggedIn && navigator.onLine;
    },

    // this is basically lifted straight from communityAssessor project, utils/Methods.js
    getDMS(nDec, bLong = false) {
      let sDir = (nDec > 0) ? 'N' : 'S';
      if (bLong) {
        sDir = (nDec > 0) ? 'E' : 'W';
      }
      const nDeg = Math.trunc(nDec);
      const nDecimal = Math.abs(nDec) - Math.abs(nDeg);
      const nMin = Math.trunc(nDecimal * 60);
      const nSec = ((nDecimal * 60) - nMin) * 60;

      const re = new RegExp('(\\d+\\.\\d{4})(\\d)');
      const m = nSec.toString().match(re);
      const nSecValue = m ? parseFloat(m[1]) : this.valueOf();

      return `${Math.abs(nDeg)}° ${nMin}' ${nSecValue}" ${sDir}`;
    },

    showOkModal(title, message) {
      this.$bvModal.msgBoxOk(
        message,
        {
          title,
          okVariant: 'success',
          okTitle: 'Okay',
          hideHeaderClose: true,
          centered: true,
        },
      );
    },
  },
};
